<template>
  <div class="index">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>
    <div class="container">
      <!-- 标题 -->
      <h3>{{ this.title }}</h3>

      <!-- 信息层 -->
      <div class="s-info">
        <img :src="this.logo" alt="">
        <div class="info-list">
          <!-- 评分 -->
          <h4><span>{{ this.pf }}</span>分</h4>
          <p>地区：中国 </p>
          <p>类型：国产动漫 </p>
          <p>年代：2024</p>
          <p>完结状态：已完结</p>
          <p>发布时间：{{ this.time }}</p>

          <!-- <a href="javascript:;" @click="gopay()">付费后观看完整漫画</a> -->

          <p>
            <!-- 章节列表： <a href="javascript:;">第一话</a> <a href="javascript:;">第二话</a> <a href="javascript:;">第三话</a> -->
            章节列表：
          </p>

          <p>
            <a href="javascript:;" v-for="(item, index) in bl" :key="index" @click="gozjlist(item)">第{{ item }}话</a>
          </p>

        </div>
      </div>

      <div class="i-con">

        <!-- 第一话数据  -->
        <img :src="item" v-for="(item, index ) in zj1" :key="index" v-show="z1show">
        <!-- 第2话数据  -->
        <img :src="item" v-for="(item, index ) in zj2" :key="index" v-show="z2show">
        <!-- 第3话数据  -->
        <img :src="item" v-for="(item, index ) in zj3" :key="index" v-show="z3show">
        <!-- 第4话数据  -->
        <img :src="item" v-for="(item, index ) in zj4" :key="index" v-show="z4show">
        <!-- 第5话数据  -->
        <img :src="item" v-for="(item, index ) in zj5" :key="index" v-show="z5show">
         <!-- 第6话数据  -->
        <img :src="item" v-for="(item, index ) in zj6" :key="index" v-show="z6show">

        <!-- 上一页,下一页 -->
        <p>
          <a href="javascript:;" v-show="syy" @click="yhs()">点击进入上一话</a>
          <a href="javascript:;" v-show="xyy" @click="yhx()">点击进入下一话</a>
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import NavHeader from "./../components/NavHeader";
export default {
  data() {
    return {
      state: JSON.parse(window.localStorage.getItem("state")),
      href: "index.html",
      // 获取 id
      myId: this.$route.query.type,
      // 获取 标题
      title: "",
      // 获取 评分
      pf: "",
      // 获取 介绍图
      logo: "",
      // 获取 时间
      time: "",
      // 获取章节数量
      bl: [],
      // 第一话数据
      zj1: '',
      zj2: '',
      zj3: '',
      zj4: '',
      zj5: '',
      zj6: '',

      z1show:false,
      z2show:false,
      z3show:false,
      z4show:false,
      z5show:false,
      z6show:false,
    
      // 上一页按钮
      syy: false,
      // 下一页按钮
      xyy: false,

      // 当前章节页
      savedItems:1

    };
  },
  components: {
    NavHeader,
  },
  mounted() {
    this.init();
    document.title = "杭州含情网络技术有限公司";
  },
  methods: {
    init() {
      this.axios.get("/mock/sound.json").then((res) => {
        var vl = res.data;
        var date = vl.find((vl) => vl.id == this.myId);
        // 标题
        this.title = date.title;
        // 评分
        this.pf = date.pf;
        // 介绍图
        this.logo = date.img;
        // 发布时间
        this.time = date.time;
        // 章节目录
        this.bl = date.buttonList;
        // 第一话数据
        this.zj1 = date.zj1
        this.zj2 = date.zj2
        this.zj3 = date.zj3
        this.zj4 = date.zj4
        this.zj5 = date.zj5
        this.zj6 = date.zj6
      });
    },


    // 章节按钮 点击逻辑
    gozjlist(item) {
      if( item == '1') {
        this.z1show = true
        this.z2show = false
        this.z3show = false
        this.z4show = false
        this.z5show = false
        this.z6show = false

        this.syy = true
        this.xyy = true

        this.savedItems = 1
      }

      if( item == '2') {
        this.z1show = false
        this.z2show = true
        this.z3show = false
        this.z4show = false
        this.z5show = false
        this.z6show = false
        
        this.syy = true
        this.xyy = true
        this.savedItems = 2
      }

      if( item == '3') {
        this.z1show = false
        this.z2show = false
        this.z3show = true
        this.z4show = false
        this.z5show = false
        this.z6show = false
        this.syy = true
        this.xyy = true
        this.savedItems = 3
      }

      if( item == '4') {
        this.z1show = false
        this.z2show = false
        this.z3show = false
        this.z4show = true
        this.z5show = false
        this.z6show = false
        this.syy = true
        this.xyy = true
        this.savedItems = 4
      }

      if( item == '5') {
        this.z1show = false
        this.z2show = false
        this.z3show = false
        this.z4show = false
        this.z5show = true
        this.z6show = false

        this.syy = true
        this.xyy = true
        this.savedItems = 5
      }

      if( item == '6') {
        this.z1show = false
        this.z2show = false
        this.z3show = false
        this.z4show = false
        this.z5show = false
        this.z6show = true

        this.syy = true
        this.xyy = true
        this.savedItems = 6
      }
    
    },

    yhs() {
     let xys = this.savedItems - 1 
     this.savedItems = xys
     console.log("xys:",xys)
     this.gozjlist(xys)
     window.scrollTo(0, 0)
     if(this.savedItems < 1) {
      alert('已经是第一页了')
     }
    },

    yhx() {
     let xyx = this.savedItems +1 
     this.savedItems = xyx
     console.log("xyx:",xyx)
     this.gozjlist(xyx)
     window.scrollTo(0, 0)
     
     if(this.savedItems > this.bl.length) {
      alert('已经是最后一页了')
     }
    }

 
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.index {
  background-color: #eee;

  .container {
    margin-top: 60px;
    padding-left: 10%;
    box-sizing: border-box;

    // 标题
    h3 {
      font-size: 21px;
      text-align: left;
      width: 100%;
      height: 40px;
      border-bottom: 2px solid #ccc;
    }

    // 信息层
    .s-info {
      width: 100%;
      display: flex;
      margin-top: 20px;

      img {
        width: 270px;
        height: 400px;
        margin-right: 25px;
        display: block;
      }

      .info-list {
        h4 {
          font-size: 14px;
          color: #333;

          span {
            color: #ff6600;
            font-size: 31px;
          }
        }

        p {
          font-size: 14px;
          color: #333;
          margin: 30px 0;
        }

        a {
          display: inline-block;
          width: 150px;
          height: 35px;
          background-color: #4b5cc4;
          text-decoration: none;
          font-size: 14px;
          color: #fff;
          text-align: center;
          line-height: 35px;
          font-weight: bold;
          transition: all .3s;
          margin: 5px;

          &:hover {
            border-radius: 20px;
          }
        }

      }
    }

    // 主容器1
    .i-con {
      width: 80%;
      text-align: center;
      margin: 15px auto;

      img {
        width: 100%;
        display: block;
        margin: 0 auto;
        text-align: center;
      }

      p {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 35px 0;

        a {
          font-size: 26px;
          text-decoration: none;
          color: #333;
          transition: all .2s;

          &:hover {
            color: #0059a5;
          }
        }
      }

    }
  }
}
</style>
